export enum ClockInResourceProviderType {
  Default = "Default",
  Shift = "Shift",
  Route = "Route"
}

export interface PlannedResourceModel {
  id: string;
  type: string;
  providerType: ClockInResourceProviderType;
}
